/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_macro_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Protein and carbohydrate each provide 4 kcal per gram; fat provides 9 kcal per gram.`)
};

const es_macro_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La proteína y los carbohidratos aportan 4 kcal por gramo cada uno; la grasa aporta 9 kcal por gramo.`)
};

const de_macro_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Protein und Kohlenhydrate liefern jeweils 4 kcal pro Gramm, Fett liefert 9 kcal pro Gramm.`)
};

const nl_macro_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eiwit en koolhydraten leveren elk 4 kcal per gram; vet levert 9 kcal per gram.`)
};

const fr_macro_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les protéines et les glucides apportent chacun 4 kcal par gramme ; les lipides apportent 9 kcal par gramme.`)
};

const it_macro_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proteine e carboidrati forniscono ciascuno 4 kcal per grammo; i grassi ne forniscono 9 per grammo.`)
};

const pt_br2_macro_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proteína e carboidrato fornecem 4 kcal por grama cada; a gordura fornece 9 kcal por grama.`)
};

const pt_macro_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A proteína e os hidratos de carbono fornecem cada um 4 kcal por grama; a gordura fornece 9 kcal por grama.`)
};

const ja_macro_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`タンパク質と炭水化物はそれぞれ1gあたり4kcal、脂質は1gあたり9kcalです。`)
};

const zh_macro_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`蛋白质和碳水化合物每克提供 4 千卡；脂肪每克提供 9 千卡。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const macro_faq_a2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.macro_faq_a2(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("macro_faq_a2", locale)
	if (locale === "en") return en_macro_faq_a2(inputs)
	if (locale === "es") return es_macro_faq_a2(inputs)
	if (locale === "de") return de_macro_faq_a2(inputs)
	if (locale === "nl") return nl_macro_faq_a2(inputs)
	if (locale === "fr") return fr_macro_faq_a2(inputs)
	if (locale === "it") return it_macro_faq_a2(inputs)
	if (locale === "pt-BR") return pt_br2_macro_faq_a2(inputs)
	if (locale === "pt") return pt_macro_faq_a2(inputs)
	if (locale === "ja") return ja_macro_faq_a2(inputs)
	return zh_macro_faq_a2(inputs)
};